import React, { Component } from 'react';
import ScoreBars from '../ScoreBars';
import { DefaultEventComponent } from './Default';

export default class YourScoreIs extends DefaultEventComponent {

    render() {
        let scoreData = this.props.receivedMessage.package.data;
        let currentRoundPoints = scoreData.current_round_points
        let currentScore = scoreData.current_score

        return <>
            <h2>This Round: {currentRoundPoints}</h2>
            <h2>Total: {currentScore} / 24</h2>
        </>;
    }

}
